
import {RenderEngine} from "./RenderEngine"
import {Controller} from "./Controller"
import { hot } from "react-hot-loader";
import React from 'react';
//import { Controller, ControllerProps, ControllerState } from "../core/controller";
import { UI } from "./UI"
import { Tree } from "./Tree";


export interface UiProps /*extends ControllerProps, ControllerState*/ {
}

interface IAppState extends UiProps {
	controller:Controller,
	tree:Tree,
}

class App extends React.Component<{}, IAppState> {
	renderReference:React.RefObject<HTMLDivElement>;
	state:IAppState = {
		controller: new Controller(),
		tree : undefined
	}

	constructor (props) {
		super(props);
		this.renderReference = React.createRef<HTMLDivElement>();

		//FIXME: DEBUG: remove!
		(window as any).app = this;
		//---
	}
	
	componentDidMount = async () => {
		this.handleFonts();
		this.onResize();
		window.addEventListener("resize", this.onResize);
		const callback = () => this.setState({});

		//DEBUG: uncomment
		this.state.controller.init(this.renderReference.current, callback);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize);
	}

	public handleFonts = () => {
		const fonts = [
      new FontFace('AssistantRegular', `url(${"public/fonts/Grandesign_Neue_Roman.ttf"}) format('truetype')`, { weight: 'normal', style: 'normal' }),
      new FontFace('AssistantRegular', `url(${"public/fonts/Grandesign_Neue_Roman_Bold.ttf"}) format('truetype')`, { weight: 'bold', style: 'normal' })
    ];

		fonts.forEach((font) => {
      font.load().then((loadedFont) => {
        document.fonts.add(loadedFont);
      })
    });
	}

	onResize = () => {
		/*
			const {clientWidth, clientHeight} =  document.documentElement;
			const mobile = clientWidth < clientHeight;
			this.setState({mobile});
		*/
	}
	
	render() {
		return (
			<div id="app" style={{fontFamily: "AssistantRegular", display: "flex", MozUserSelect: "none", msUserSelect: "none", userSelect: "none", WebkitUserSelect: "none"}}>
				<UI controller={this.state.controller}></UI>
				<div id="render" ref={this.renderReference} style={{display: "flex", width: "100vw", height: "100vh"}}/>
			</div>
		)
	}
}

export default hot(module)(App);